import React, {useState} from "react";
import CreateAccountForm from "./CreateAccountForm";
import PropTypes from "prop-types";
import {SIGNUP_USER_TYPES} from "../../../../constants";

const CreateClearStepClientAccount = ({ onAccountCreated, appName }) => {
  const [signupUserType, setSignupUserType] = useState(null);

  const SignupUserTypeChoice = ({ caption, type }) => (
    <button key={caption}
            className={`${type === signupUserType ? "button-outline-selected" : "button-outline"} next-button-txt next-step-button`}
            style={{ width: "250px", margin: "10px", fontWeight: "bold", paddingLeft: 0, paddingRight: 0 }}
            onClick={() => setSignupUserType(type)}
    >
      {caption}
    </button>
  );

  return (
    <React.Fragment>
      <div className="col-lg-10 mt-3">
        <div className="next-button-txt text-muted mb-lg-2">
          Will you be using MyClearStep for yourself or
          <br/>
          for your child/dependent?
        </div>

        <SignupUserTypeChoice caption="Myself" type={SIGNUP_USER_TYPES.DEFAULT} />
        <SignupUserTypeChoice caption="My child or dependent" type={SIGNUP_USER_TYPES.PARENT} />

        {signupUserType === SIGNUP_USER_TYPES.PARENT &&
          <p className="next-button-txt text-muted mb-lg-2 mt-3">
            Create an account below to get started.<br/><span className="fw-bold">You will use the same email and password to access the measurement data and manage your billing.</span>
          </p>
        }

        {signupUserType === SIGNUP_USER_TYPES.DEFAULT &&
          <p className="next-button-txt text-muted mb-lg-2 mt-3">
            Create an account below to get started.<br/><span className="fw-bold">You will use the same email and password to log in to the MyClearStep app.</span>
          </p>
        }
      </div>

      {signupUserType && <CreateAccountForm onAccountCreated={onAccountCreated} appName={appName} signupUserType={signupUserType} />}
    </React.Fragment>
  );
};

CreateClearStepClientAccount.defaultProps = {
  onAccountCreated: () => {}
};

CreateClearStepClientAccount.propTypes = {
  onAccountCreated: PropTypes.func,
  appName: PropTypes.string.isRequired
}

export default CreateClearStepClientAccount;